import { parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";
import { Tables } from "@/gen/tableNames/tables";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { dynamicFormFields } from "./form-conf";

export type N1Plans = {
  id: number;
  date?: string | null;
  strategy_id: number;
  strategy_name: number;
  portfolio_id?: number | null;
  portfolio_name?: string | null;
  credit_quality_step?: number | null;
  book_value?: number | null;
  created_at: string;
  updated_at: string;
};

const t = (key: string, defaultValue: string) =>
  i18n.t(`${Tables.N1_PLANS}.columns.${key}`, {
    ns: "tables",
    defaultValue,
  });

export const n1_plans_columns: ColumnDef<N1Plans>[] = [
  {
    accessorKey: dynamicFormFields.id,
    header: () => t(dynamicFormFields.id, "ID"),
  },
  {
    accessorKey: dynamicFormFields.name,
    header: t(dynamicFormFields.name, "Name"),
  },
  {
    accessorKey: dynamicFormFields.asset_class_1,
    header: t(dynamicFormFields.asset_class_1, "Classe d'actifs"),
  },
  {
    accessorKey: dynamicFormFields.asset_class_2,
    header: t(dynamicFormFields.asset_class_2, "Sous-classe d'actifs"),
  },
  {
    accessorKey: dynamicFormFields.vehicle,
    header: t(dynamicFormFields.vehicle, "Vehicle"),
  },
  {
    accessorKey: dynamicFormFields.lpt_fund_vintage_start_date,
    header: () =>
      t(
        dynamicFormFields.lpt_fund_vintage_start_date,
        "Fund vintage start date",
      ),
    cell: ({ row }) => {
      const value = row.getValue(dynamicFormFields.lpt_fund_vintage_start_date);
      return value ? parseDate(String(value)) : "";
    },
  },
  {
    accessorKey: dynamicFormFields.lpt_investment_period_end_date,
    header: () =>
      t(
        dynamicFormFields.lpt_investment_period_end_date,
        "Investment period end date",
      ),
    cell: ({ row }) => {
      const value = row.getValue(
        dynamicFormFields.lpt_investment_period_end_date,
      );
      return value ? parseDate(String(value)) : "";
    },
  },
  {
    accessorKey: dynamicFormFields.lpt_investment_duration,
    header: t(dynamicFormFields.lpt_investment_duration, "Duration"),
  },
  {
    accessorKey: dynamicFormFields.lpt_expected_investment_return,
    header: t(dynamicFormFields.lpt_expected_investment_return, "Rendement"),
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
